
      <!-- Default box -->
      <div class="card card-info"  [ngClass]="{'dark-bg' : isDark }">
        <div class="card-header">Room Details</div> 
        <form [formGroup] ="itemForm" autocomplete="off" (ngSubmit)="saveButtonClick()" class="form-horizontal" enctype="multipart/form-data">
        <div class="card-body">  

        <div class="form-group row">
            <input  name="id" readonly formControlName="id"  class="form-control"    type="hidden">
        </div>
  
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="roomId" class="col-form-label">Room Id</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-hashtag"></i></span>
                  </div>
                  <input type="text"  [ngClass]="{'dark-input-field' : isDark }" [readonly]="isItemCodeReadOnly" formControlName="roomId" class="form-control field-bg-color"  placeholder="Room Id" [class.is-invalid]="formErrors.roomId" (blur)="logValidationErrors()">
                </div>
                <span class="text-danger" *ngIf="formErrors.roomId"><small>{{formErrors.roomId}}</small> </span> 
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="roomType" class="col-form-label">Room Type</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-bars"></i></span>
                  </div>    
                  <select  [ngClass]="{'dark-input-field' : isDark }" class="form-control" formControlName="roomType"  [class.is-invalid]="formErrors.roomType" (blur)="logValidationErrors()" >
                    <option [ngValue]="null">-Select-</option>
                    <option  *ngFor="let item of roomType" [value]="item.value">
                      {{item.value}}
                    </option>
                  </select>
                </div>
                <span class="text-danger" *ngIf="formErrors.roomType"><small>{{formErrors.roomType}}</small> </span>   
              </div>
            </div> 
            <div class="col-md-4">
                <div class="form-group">
                  <label for="roomNo" class="col-form-label">Room No</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="far fa-list-alt"></i></span>
                    </div>
                    <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="roomNo" class="form-control"  placeholder="Room No" [class.is-invalid]="formErrors.roomNo" (blur)="logValidationErrors()">
                  </div>
                  <span class="text-danger" *ngIf="formErrors.roomNo"><small>{{formErrors.roomNo}}</small> </span> 
                </div>
              </div> 

          </div>
  
          <div class="row">
              
            <div class="col-md-4">
                <div class="form-group">
                  <label for="roomExtNo" class="col-form-label">RoomExtNo</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-cubes"></i></span>
                    </div>
                    <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="roomExtNo" class="form-control"  placeholder="Room Ext. No">
                  </div>  
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label for="breakfast" class="col-form-label">Breakfast</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-edit"></i></span>
                    </div>
                    <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="breakfast" class="form-control"  placeholder="Breakfast">
                  </div>               
                </div>
              </div> 

             <div class="col-md-4">
              <div class="form-group">
                <label for="bedType" class="col-form-label">Bed Type</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="	fa fa-bars"></i></span>
                  </div>    
                  <select  [ngClass]="{'dark-input-field' : isDark }" class="form-control" formControlName="bedType" >
                    <option [ngValue]="null">-Select-</option>
                    <option  *ngFor="let item of bedType" [value]="item.value">
                      {{item.value}}
                    </option>
                  </select>
                </div>
              </div>
            </div>  

          </div>

          <div class="row">
              
            <div class="col-md-4">
                <div class="form-group">
                  <label for="otherFacilities" class="col-form-label">Other Facilities</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-cubes"></i></span>
                    </div>
                    <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="otherFacilities" class="form-control"  placeholder="Other Facilities">
                  </div>  
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label for="availability" class="col-form-label">Availability</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-edit"></i></span>
                    </div>
                    <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="availability" class="form-control"  placeholder="Availability">
                  </div>               
                </div>
              </div>
              
              </div>
      
        </div>
        <!-- /.card-body -->
        <div class="card-footer">
         <button type="button" (click)="newButtonClick()" class="btn btn-success ml-2">New</button>

          <button *ngIf="crud_access.create"  type="submit"  class="btn btn-info ml-2">
           <span *ngIf ="showProcessingIndicator" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Save
          </button>
  
          <button type="button" class="btn btn-primary ml-2" routerLink="../room-details-list"><i class="fa fa-table p-1"></i>Room Details List</button>
        </div>
        <!-- /.card-footer-->
        </form>
      </div>

  


